(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var btn = event.target.closest('.card-quantity-stepper__btn');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    var stepper = btn.closest('.card-quantity-stepper');
    var input = stepper.querySelector('.card-quantity-stepper__input');
    var next = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.step, 10);
    input.value = Math.max(1, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  } catch(e) { console.error(e); }
})();

})();
